export function getDisplayStreamName(streamNameByUser, fallbackStreamName) {
  if (streamNameByUser === null || streamNameByUser === undefined) {
    return fallbackStreamName;
  }

  if (typeof streamNameByUser === 'string') {
    return streamNameByUser.trim() !== '' ? streamNameByUser : fallbackStreamName;
  }

  return streamNameByUser || fallbackStreamName;
}
